import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import _ from 'lodash';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableSortLabel, Collapse, Grid, IconButton, Tooltip } from '@material-ui/core';
import { DistanceFormatter, DurationFormatter, WaterwayClassFormatter } from './formatters';
import { Cell } from './Styled';
import { useSelector, useDispatch } from 'react-redux';
import searchResults from '../../reducers/searchResults';
import InfoIcon from '@material-ui/icons/Info';

function getOrderField(orderBy, route) {

	switch (orderBy) {
		case 'distance':
			return 'route.distance';
		case 'minClass':
			return 'route.minClass';
		case 'sluices':
			return 'route.sluices.length';
		case 'totalShips':
			return `ships[${_.findIndex(route.ships, ship2 => _.minBy(route.ships, (ship) => ship.numberOfShips).numberOfShips === ship2.numberOfShips)}].numberOfShips`;
		default:
			throw new Error('Cant sort on ' + orderBy);
	}
}


function stableSort(array, order, orderBy) {
	const clone = array.slice();

	clone.sort((a, b) => {
		const keyA = get(a, getOrderField(orderBy, a));
		const keyB = get(b, getOrderField(orderBy, b));

		if (order === 'asc') {
			return (keyA < keyB) ? -1 : (keyA > keyB) ? 1 : 0;
		} else {
			return (keyA < keyB) ? 1 : (keyA > keyB) ? -1 : 0;
		}
	});

	return clone;
}
// {
// 	SluiceTime: 135,
// 	DistanceUpStream: 0,
// 	DistanceDownStream: 0,
// 	DistanceNoStream: 175.995,
// 	Start: {
// 		Latitude: 52.3810296,
// 		Id: 20291,
// 		Longitude: 4.9029685
// 	},
// 	ContainerLevels: 3,
// 	Polyline: 'mtu~Hqr|\\iBtJyFtL??fHfKfErE|DdFvGbItI|JvHjIbA|@vElAjHxAdKhA|Db@t@Ix@}@nDuFhAuC^yEBuECiCeAqD@eA@wC[eDPiMnA_KzAaDfBaAh^aOpSmHfNqGnJeJ`PmN|MkGbQaEpNiH`HKtGjJhDhNfDtNxGlE~HdBvD~C~BnF~@~F@fIPnHpAjDnB`BlDU~Fw@`EhCtIfHjOvGpEh@`Ds@pCiDdBsEdA_JPgLvAsJ`CaJxDaSnCoDhBBnB~BbC`IdBpEzBhAvDiAbE{@vCr@nDxApFl@hEcAtD}C~CkDtByAdDk@nDtAtClEnHfM`Qf\\nDdDpCY|CgC~BgDjCwDtBg@pBbD??n@vFfAj`@t@rFv@hD`BdCfCRpGBlBBfAnAz@~CjClLdCtBnAK~Cd@nJvEnD~CfCd@xFvBvQjVnG|GpBhAdBc@tCyAzCmB~EcGrCoAzB@xBb@lBd@lCe@rBg@tAf@tHpCdJxCvCdAlB[tC_DhEoHrAw@dB?nAdAxDnGnEjHjAfF\\tINzIn@jD`ApAzBTzF{@pBKrE~A`JdKfEpCrD~@~GfEjBhDd@`IjGjMjGdPzCvMT`Fh@hCpA`@`Cj@d@`Cn@nBnBbAfEPrJTfBv@NbC?|CKxDArBb@rAfA`@hF{BbBa@|An@dAhAf@jADnBk@|BoC`IUbCH~Af@bAtAVdDd@rAl@v@fBn@`Fv@fFb@vAtBh@~AFzAd@b@rB@nE??CrGRvG??zAzElC|DnD~Ej@tEhA~GbHlLz@rG~BbQp@bOhDdN??HlJpBrKjClFfAlH\\`LAdMXhE[nFsAzEwAbE?jD`ArErA`GbA`FJfJ^xI@bNa@dH}@vHmC~QSzF@vG_AdDw@~Be@~CG`FF~HR|EjArEnAvFx@xGf@fCpBhAfDvA`EfCzDnE|HzS`ItVpHdMnEpJ`CvNFdKHdWVvEx@~B`HhJ`BrIxAtGOxUh@nBbFhFlLfOtKjMlMtM??\\^RZThA??S`B_@nBe@jBy@rBsBtCuBxCoC|D}@rAo@jAi@rBWrAOl@e@pAk@r@m@x@m@xAk@dBs@tB_@~@OTUTc@^U\\Qp@Gd@C\\Cr@Cv@IjBc@bCg@~EkAhIe@~Co@~Cm@xBo@dCq@pEq@pF{@fFu@vDw@rEkAfFcBhF_BvGq@jEaA~H_AtFmArEoAzBoAjBq@|Ao@nBa@dBa@fCu@~GqAlM}@dJw@`K[fFIzFG`HC~HSpDWrB[jBc@|BOtAExBFnCl@lLz@pO|@rL`@dDTdCHnB@lBAr@?T?h@B~@NzB`@fItAhU`ArMjAxRhAlPnArQn@`Iz@hDv@hKlAfO|@tI??hL{BbKaD??pQmEhFcAlEwA~UwJtVoB|NbEbOrJjQt[rMzZxLzKnMtHpEvJpGpFzHbA~IqA??rVoQrOsFhFmAvEwB`AJbAe@tIqCjF{@|@w@vH_E|LqE~VqFzPwD`NmElAi@zD?dNaEtEi@zFqAtF_AzFuAhFw@|DYzBUtBiB??_@sEQgCQkHAmHXeFXaEf@}FzAsOpAqInB_FhC}CjCmA`D_AxCWfCE|BCnEGrCLpEM~FQtFd@|D\\hBPzCRlCBzCDtDM~Fk@fCu@pCgAjDmBrC{CjBwDbDgLhCiOhAuFt@oGd@qDt@qB??|Bv@rDxB~Bn@zAn@dBh@tA`@tBj@bD~AzExC??fKnExM|FnT~JxVfM`FvCnC~@jGr@`Uv@hQv@rS|AzGp@vDPx@G|Db@rMh@~CFh@VvB^lDTfATnATjA?fCLrAJ`AT~B^tDZdAJdAd@vBZnBApAUlAY|A?bLfB`EfAtH`BtH`B~AH`FgA`Es@pCo@nBqAxCiBfGyEdEyCpCsBhD_B`A[nBOl@H~FbBrBn@nBj@dInBpARxGVrBp@hAf@dAl@lBhAbBXrC\\`F~@dCd@fBLz@]pBMxA\\jCj@hBE|CTfDr@|Dz@jEh@zDDpD?bC`@xAR~BEnC_@nLsBvA]zEaBtA_AxAcAnDkEhBgBvAaAtAiAv@eBv@mC|@qCpBiC|AmBxBsC~AiAj@{@pAmA|BeBdAyA~@yAh@sAl@oBb@oCFcFX}FpA{Fz@yE^qKrAcJlBoF~BcDfFeBpJkDbKaC??~GqCpEuCtBeBnCyChBcCnC{EfCuEfBsCdAeB|DqGjEoElEoBjGgBrD{@zEt@bBZ??dDn@rEz@|EfC|E|DbDtE??x@tHlCtEnCzGlDhG|AdFdB`GlBvErD`HvFtDvFlErD`DbCnF~@nFrBxFxCtEbEhCpEr@lFz@fGV~Cb@fE~FbBhNx@zKtAlLvCnJbCjKr@xRlAxHzB|GbDxF~CfJpD`GnBpIlBvV~@bJ~ApHhBvHl@xQUfHjBfHrCpEzBpC`AL??nAg@dC}AtEeGvHeMdE_HhEgJfDoGhDeDvHuJbDmCfGoF`F{DvCoDnEsBfCnAvAhC??jArHh@bM??xBpGfCrDfD~AxD`@lGl@nFKvGpAbHnD~Dz@`Fd@`JfDpE|ApFXrExCvBhEp@tGDbS[~IIjKnBvOtC`IrFrFbMfJn^fVbEvF~@zIMhGqAfJsArO_BlNEnFL~Gh@zFdBlH|ExPnExLfD`H??fC|JpCbO??bBpPlCdLjEnFzDdF|DhB??jEzB`I|BhC~E??x@{Dnk@kx@~AqEjAeEnAiBl@c@|@XtBrAzA?`D@??~@yCjAuDjHaSnAwEbAeDzBeGxAyF~AgHXuC|@aDxAeG`CsBzCmGnAaLbAkJd@oK|@iGnAmKjBaIxE_LdKaTzAa@tAjA|@tG??lCmAnDwBbFmEbFyFhEmEfEsDhDqCbGsDrGkDvKiG`JkF??rFqEhHaGpGuEbGgFhDoFxDeIlCiGbDgJhDoIbDiGhEgJbGiKhEsGlFiGrGkHlFwF|EsG|GwFxGuErGuDbGmE|FcE|EgFnEgJvDyFnF}H??fGeI??bGmIbGkH|FsGbGmEbGyCbG}AbGYlE|AhEpChEpC|FxChKxB|H`@pI{@vJi@??jHjBtGrCzDhCxDvFlBjH??nBhGrBlHdDjHbDjHbCpGrCjHhE|HbGdIxDnFhDxFrCfFtCtEvDtEdDpCbE`GrDdIhEfMhD`KbDhKbC`KtCdLhDxRlBxN??zA|Lx@hNr@|L??hGiBlI_B|HuA??jKmAtJ}C??~D_AvGqCxHsDbIaD??|I{CbJ{@lO_A??zH\\hI\\rGL~E\\|IbAzEn@rGd@tE\\~G?`HJvGG`L_AzH{@~HiAtGcCvF{BrEkBzH{BvGsBzIaBnHiA~Ks@tG\\hIT`EJ|Ej@lHfA|Gv@fIdAlGbArHrBpFlAvHdBxFxAjEvBrHtCbGdCfI|EnLpF??`SjK|UrO|\\rVf\\zZ|Ync@??tKpUfOnd@dJpe@??h@fZN|HnGl`A??zKzzAjDnm@`@dp@_FfuAwElgA??oBdcA_GfmA_Etf@??sAfVsDpz@iCx~@uCbqAiArm@Ibm@p@li@??|A`QjDlOrEvO|Rre@tBrEnBhE|E`LzCnG??lCdGrBvEdA|B`BjDvArDpBfFlCtGtAjDlBpExBpF`DfH~B~I~DxGhCtErB`GtD|LdFxFfGfFhJdIhL`O~QfQ|X`]|HbH~FdI~GvQ~DzKbD`R??jJpU|H|[hIb^tLtm@lErb@nExc@`Ejc@rLxdAhHxv@|Jlq@tEb_@rSppA~Hr`B~Bpd@^zK??~Fnl@~Glh@|Kbm@??jEtP|EnU~BnM~CpUtExY~DlThGrV~GzS~GfQ|KhRtLnMhJ|LtGlE~JbH|I~EjJzD~FtArEr@~FvBhIdBtH?hLPhJ?~HcAtKgBhLoFzJsDnFsDhDaCnBwBtCaDxDsD~CuDnCyCnDgFhCkDdDoFxByCnB_CdCmEhE{GzB{DbBqCzAaCrBsDnA_CnAaCzBgCbDsGjBsDbBsDzC_CbCkDzC{D~C_F~DoFrCmE~BeEnCmE~B{DnCkD~CeE~BwBdCsDtBwBdD{D~AyBhBoCdDuDnCwBhDyCnBoB~CyCdCwB~AmAnBeBhBgBdBq@nBmA~Bs@nBi@hC{@nCs@`Es@bEs@~D{@zCa@rDi@~AYdCa@tDs@dC?~DQ~BXhC`@tC~AhDtA~BbAjDz@nCbAnBXtClAhBxCnApCdAxChDnBtGdE~HxCnGxCzGjDnKtEzIlErIjD`HjD~FbDdPtInKrG??fc@|LtMdBhLfBvOfChRa@tMsHpKwL??z_AmG??re@oGzgCs[|AHzAEnAGnBi@nCaA|C]~BGnCKhC]pBe@rBa@rB[bCa@lC_@hCC|D_@bGu@??bH}@v@GnRoApQyApKcAdPgBrOkApOsAxj@eHzg@_GtwAmOfIiA`OsBdJaBxIqBhH}BzGiCbHyDvHqF`GgFzJ{KzHkKdH{K`H}L~GcPbDkIdDyJxDiOdF}WfBmLbBgLpAcQd@{Ov@m`@Xo\\ZqYn@sStA}LnC}HtCmEtFqChoB}AhIN??lHlA`DbApB~@fClB~AnCfBrF??N`DLdEB|FAxHUnM??rF{E',
// 	End: {
// 		Description: 'Antwerpen All',
// 		TerminalType: 2,
// 		Town: 'Anwerpen',
// 		ReturnTime: 0,
// 		TerminalId: 1335,
// 		Latitude: 51.3447676,
// 		Id: 101415,
// 		WaitTime: 30,
// 		Longitude: 4.2913198
// 	},
// 	MaxClass: 1,
// 	Distance: 175.995
// }

const DetailsHeader = ({ children }) => <span style={{ fontWeight: '500' }}>{children}</span>;
const DetailsValue = ({ children }) => <span>{children}</span>;
const DetailsRow = ({ header, value }) => <>
	<Grid item xs={6} style={{ display: 'flex', alignItems: 'center', height: 32 }}><DetailsHeader>{header}</DetailsHeader></Grid>
	<Grid item xs={6} style={{ display: 'flex', alignItems: 'center', height: 32 }}><DetailsValue>{value}</DetailsValue></Grid>
</>;

const RouteDetails = ({ route, ships, duration, containerCargo }) => {
	const showShipInfo = () => {
		window.open('scheepstypen.pdf');
	};

	const renderTonnesCapacity = (ship) => <FormattedMessage id={'ROUTE.MAXCAPACITYVALUETONNES'} values={{ value: ship.shipType.capacityWeight }} />;
	const renderTeuCapacity = (ship) => <FormattedMessage id={'ROUTE.MAXCAPACITYVALUETEU'} values={{ value: ship.shipType.capacityTeu }} />;

	return <Grid container>
		{ships.map(ship => <React.Fragment key={ship.shipType.key}>
			<DetailsRow header={<span><FormattedMessage id={'ROUTE.SHIPTYPE'} /><IconButton size="small" onClick={showShipInfo}><InfoIcon /></IconButton></span>} value={ship.shipType.name} />
			<DetailsRow header={<span><FormattedMessage id={'ROUTE.SAILINGTIME'} /><Tooltip title={<FormattedMessage id={'ROUTE.SAILINGTIMEINFO'} />}><IconButton size="small"><InfoIcon /></IconButton></Tooltip></span>} value={<DurationFormatter duration={duration} showMinutes />} />
			<DetailsRow header={<FormattedMessage id={'ROUTE.MAXCAPACITY'} />} value={containerCargo ? renderTeuCapacity(ship) : renderTonnesCapacity(ship)} />
			<DetailsRow header={<FormattedMessage id={'ROUTE.MAXCONTAINERLEVELS'} />} value={ship.shipType.maxContainerLevels} />
			<DetailsRow header={<FormattedMessage id={'ROUTE.NUMBEROFSHIPS'} />} value={ship.numberOfShips} />
		</React.Fragment>)}
	</Grid>;
};


export default function RoutesTable({ collapsedRows, setCollapsedRows, order, orderBy, createSortHandler }) {
	const { routes, selectedRoute, search } = useSelector(state => state.searchResults);
	const dispatch = useDispatch();
	const selectRoute = (index) => dispatch(searchResults.actions.selectRoute(index));
	const deselectRoute = (index) => dispatch(searchResults.actions.selectRoute(null));
	const containerCargo = search.cargoType === 'container';

	const headCells = [
		{ id: 'distance', label: <FormattedMessage id="DISTANCE" />, sort: true },
		{ id: 'minClass', label: <FormattedMessage id="WATERWAY_CLASS" />, sort: true },
		{ id: 'sluices', label: <FormattedMessage id="NUMBEROFSLUICES" />, sort: true },
		{ id: 'totalShips', label: <FormattedMessage id="TOTALSHIPS" />, sort: true },
	];

	return (
		<TableContainer style={{ marginBottom: '24px' }}>
			<Table>
				<TableHead>
					<TableRow>
						{headCells.map(headCell => (
							<TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false} style={{ fontWeight: '600', fontSize: '13px' }}>
								{headCell.sort ? <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : 'asc'} onClick={createSortHandler(headCell.id)}>
									{headCell.label}
								</TableSortLabel> : headCell.label}
							</TableCell>
						))}
					</TableRow>
				</TableHead>

				<TableBody>
					{routes && routes.length > 0 ? stableSort(routes, order, orderBy).map((routeholder, index) => {
						const route = routeholder.route;
						const selected = selectedRoute === index;

						return (
							<React.Fragment key={index}>
								<TableRow
									hover={true}
									onClick={() => selected ? deselectRoute(index) : selectRoute(index)}
									selected={selected}>
									{headCells.map((cell, cellIndex) => {
										switch (cell.id) {
											case 'distance':
												return <Cell key={cellIndex}><DistanceFormatter distance={route.distance} /></Cell>;
											case 'minClass':
												return <Cell key={cellIndex}><WaterwayClassFormatter waterwayClass={route.minClass} /></Cell>;
											case 'sluices':
												return <Cell key={cellIndex}>{route.sluices.length}</Cell>;
											case 'totalShips':
												return <Cell key={cellIndex}>{_.minBy(routeholder.ships, (ship) => ship.numberOfShips).numberOfShips}</Cell>;
											default:
												return <Cell key={cellIndex} />;
										}
									})}
								</TableRow>
								<TableRow>
									<TableCell colSpan={headCells.length} style={{ paddingBottom: 0, paddingTop: 0 }}>
										<Collapse in={selected} timeout="auto" unmountOnExit>
											<RouteDetails route={route} ships={routeholder.ships} duration={routeholder.duration} containerCargo={containerCargo} />
										</Collapse>
									</TableCell>
								</TableRow>
							</React.Fragment>
						);
					}) : <TableRow>
						<TableCell colSpan={headCells.length} style={{ textAlign: 'center' }}><FormattedMessage id="NO.RESULTS.FOUND" /></TableCell>
					</TableRow>
					}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
